// extracted by mini-css-extract-plugin
export default {"container":"VideoModal_container__236pv"};